module.exports = __webpack_public_path__ + "static/media/youtube-logo.8842b510.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Footer/youtube-logo.svg
 ** module id = 1311
 ** module chunks = 0
 **/